import IconLaneJungle from './IconLaneJungle';

export default IconLaneJungle;